import { Check } from "lucide-react";
import { yearsSinceFounding } from "@/lib/school-age";
import { Card } from "@/components/ui/card";

const AboutSection = () => {
  const highlights = [
    `${yearsSinceFounding()}+ years of excellence in early childhood education`,
    "SPARK 5-Star Quality Program (Oregon's highest rating)",
    "Creative Curriculum with TS GOLD® assessment tools",
    "Rich S.T.E.A.M. learning focus",
    "Relationships-first approach built on trust and respect",
    "Individualized learning paths for each child"
  ];

  return (
    <div id="about" className="animate-fade-in">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          {/* Cream frame with shadow */}
          <div className="rounded-3xl p-8 overflow-hidden bg-[#fffdd0] shadow-spark-frame">
          <Card className="overflow-hidden transition-all border-0 shadow-none rounded-3xl bg-transparent p-8 md:p-12">
          <div className="max-w-4xl mx-auto text-center mb-12 animate-fade-in-up">
            <h2 className="font-header text-2xl font-black text-[#2C003E] mb-6">
              OUR STORY
            </h2>
            <p className="text-base text-[#2C003E] leading-relaxed">
              Since 1987, The Children's Hour Academy has grown from a loving home-based program into the nurturing school it is today. After years of growth inside Hope Community Church in Lake Oswego, where we remodeled classrooms, added a gym, and created a space just for infants, we found our forever home here in this welcoming corner of the commercial complex in March 2007. Through every season of change, our vision has remained the same: to provide a space where children are known, cherished, and guided with respect, trust, and care.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {highlights.map((highlight, index) => (
              <div 
                key={index}
                className="flex items-start gap-3 animate-fade-in"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="h-6 w-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ backgroundColor: '#5E2DB4' }}>
                  <Check className="h-4 w-4 text-white" />
                </div>
                <p className="text-[#2C003E] font-medium">{highlight}</p>
              </div>
            ))}
          </div>
          </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
